var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Add details")])]), _c('a-row', [_c('a-col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      }
    }
  }, [_c('a-form-model', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('a-form-model-item', {
    ref: "userName",
    attrs: {
      "prop": "userName",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Username (email)"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.userName.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "userName", $$v);
      },
      expression: "form.userName"
    }
  })], 1), _c('a-form-model-item', {
    ref: "firstName",
    attrs: {
      "prop": "firstName",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "First name"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.firstName.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "firstName", $$v);
      },
      expression: "form.firstName"
    }
  })], 1), _c('a-form-model-item', {
    ref: "lastName",
    attrs: {
      "prop": "lastName",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Last name"
    },
    on: {
      "blur": function blur() {
        _vm.$refs.lastName.onFieldBlur();
      }
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "lastName", $$v);
      },
      expression: "form.lastName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Display name"
    }
  }, [_c('a-input', {
    staticStyle: {
      "background-color": "white !important",
      "color": "black"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.displayName,
      callback: function callback($$v) {
        _vm.displayName = $$v;
      },
      expression: "displayName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Participant"
    }
  }, [_c('a-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-search": "",
      "option-filter-prop": "children",
      "allowClear": "",
      "filter-option": _vm.filterOption,
      "value": _vm.form.participant == null ? undefined : _vm.form.participant
    },
    on: {
      "change": _vm.handleChangeParticipant
    }
  }, [_vm.isEdit ? _c('a-select-option', {
    key: _vm.currentUser.participant.id,
    attrs: {
      "value": _vm.currentUser.participant.id
    }
  }, [_vm._v(" " + _vm._s(_vm.currentUser.participant.name) + " ")]) : _vm._e(), _vm._l(_vm.unallocatedParticipants, function (participant) {
    return _c('a-select-option', {
      key: participant.id,
      attrs: {
        "value": participant.id
      }
    }, [_vm._v(_vm._s(participant.name))]);
  })], 2)], 1), _c('div', {
    staticClass: "float-right"
  }, [_c('a-space', {
    attrs: {
      "space": 16
    }
  }, [_vm.isEdit ? _c('a-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.resendActivationEmail
    }
  }, [_vm._v(" Resend activation email ")]) : _vm._e(), _vm.isEdit ? _c('a-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v(" Reset password ")]) : _vm._e(), _c('a-button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Save ")])], 1)], 1)], 1)], 1)], 1)], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }